import moment from 'moment'
const helpers = {
    dateFormats:{
        date: 'DD/MM/YYYY',
        time: 'HH:mm',
        datetime: 'DD/MM/YYYY HH:mm',
        datetimesec: 'DD/MM/YYYY HH:mm:ss',
    },
	formatDate: function (value: any, utc: boolean = false) {
		if (value) {
            if(utc){
                return moment.utc(String(value)).format(this.dateFormats.date)
            }
			return moment(String(value)).format(this.dateFormats.date)
		}
		return ''
	},
	formatTime: function (value: any, utc: boolean = false) {
		if (value) {
            if(utc){
                return moment.utc(String(value)).format(this.dateFormats.time)
            }
			return moment(String(value)).format(this.dateFormats.time)
		}
		return ''
	},
	formatDateTime: function (value: any, utc: boolean = false) {
		if (value) {
            if(utc){
                return moment.utc(String(value)).format(this.dateFormats.datetime)
            }
			return moment(String(value)).format(this.dateFormats.datetime)
		}
		return ''
	},
	formatDateTimeSec: function (value: any, utc: boolean = false) {
		if (value) {
            if(utc){
                return moment.utc(String(value)).format(this.dateFormats.datetimesec)
            }
			return moment(String(value)).format(this.dateFormats.datetimesec)
		}
		return ''
	},
	moneyFormat: function (amount: any, currency: boolean = true) {
        let value = this.parseFloat(amount);
        let options: any = {
			style: 'decimal',

			// These options are needed to round to whole numbers if that's what you want.
			minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
			maximumFractionDigits: 2 // (causes 2500.99 to be printed as $2,501)
		};
        if(currency){
            options.style = 'currency';
            options.currency = 'USD';
        }
		const format = new Intl.NumberFormat('en-US', options);
		return format.format(value)
	},
	moneyFormatNew: function (amount: any, places: number = 2, currency: boolean = true) {
        let value = this.parseFloat(amount);
        let options: any = {
			style: 'decimal',

			// These options are needed to round to whole numbers if that's what you want.
			minimumFractionDigits: places, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
			maximumFractionDigits: places // (causes 2500.99 to be printed as $2,501)
		};
        if(currency){
            options.style = 'currency';
            options.currency = 'USD';
        }
		const format = new Intl.NumberFormat('en-US', options);
		return format.format(value)
	},
	numberFormat: function (value: number) {
		const format = new Intl.NumberFormat('en-US', {
			maximumFractionDigits: 0
		})
		return format.format(value)
	},
	percentFormat: function (amount: any) {
        let value = this.parseFloat(amount);
		const format = new Intl.NumberFormat('en-US', {
			style: 'percent',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		})
		return format.format(value / 100)
	},
    percent: function (amount: any, percent: number){
        let num = this.parseFloat(amount);
        let pr = this.parseFloat(percent);
        let a = 0;
        if(num > 0 && pr > 0){
            a = (num/100) * pr;
        }
        return Number(a.toFixed(2));
    },
    afterPercent: function (amount: any, percent: number){
        let num = this.parseFloat(amount);
        let cut = this.percent(num, percent);
        // console.log(num, cut)
        let a = num - cut;
        return Number(a.toFixed(2));
    },
	parseInt: (num: any): number => {
        if(!(typeof num === 'string' || typeof num === 'number') || num === null){
            num = 0;
        }
		num = num ?? 0;
		let output = 0
		if (typeof num === 'number') output = Math.trunc(num)
		else output = parseInt(num.trim())

		if (isNaN(output)) {
			output = 0
		}
		return output
	},
	parseFloat: (num: any): number => {
        if(!(typeof num === 'string' || typeof num === 'number') || num === null){
            num = 0;
        }
		num = num ?? 0;
		let output = 0;
        // console.log(typeof num, num)
		if (typeof num === 'number') output = num
		else output = parseFloat(num.trim())

		if (isNaN(output)) {
			output = 0
		}
		return output
	},
	newLineSplit: (str: string | null | undefined, comma: boolean = false): string[] => {
		const output: string[] = [];
		str = (str ?? '').trim();
		if(comma){
			str = str.replace(/,/g, "\n");
		}
		const arr = str.split(/\r\n|\r|\n/);
		for(let item of arr){
			item = item.trim();
			if(item.length){
				output.push(item);
			}
		}
    
		return output;
	},
    ucFirst: (str: string | null) => {
        str = str ?? '';
        str = str.trim();
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    goBack: () => {
        window.history.back();
    },
    readableBytes: (bytes: number | undefined): string => {
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        if (typeof bytes === "undefined" || bytes === 0) return '0 B';
        
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        const result = (bytes / Math.pow(1024, i)).toFixed(2);
        
        // Remove .00 if the result is a whole number
        return (result.endsWith('.00') ? parseInt(result) : result) + ' ' + sizes[i];
    },
    numberFormatter: function(value: any, precision: number = 2, positive: boolean = true){
        if(!(typeof value === 'string' || typeof value === 'number') || value === null){
            return null;
        }
        value = this.parseFloat(value);
        if(!value){
            return null;
        }
        if(positive && value < 0){
            value = 0;
        }
        return Number(value.toFixed(precision));
    },
    numberFormatterReq: function(value: any, precision: number = 2, positive: boolean = true){
        if(!(typeof value === 'string' || typeof value === 'number') || value === null){
            return 0;
        }
        value = value ?? 0;
        value = this.parseFloat(value);
        if(positive && value < 0){
            value = 0;
        }
        return Number(value.toFixed(precision));
    },
    numberParser: function(value: string){
        return this.parseFloat(value);
    },
    scrollIntoView: (el: Element | null, offset: number = 20) => {
        // const el = (event.target as HTMLElement).closest('.bin-card');
        // If parent exists, scroll it into view with an offset
        if (el) {
          let topbarHeight = document.querySelector('.app-top-bar')?.clientHeight || 0; // Adjust this to your topbar's height
          topbarHeight += offset;
          let parentPosition = el.getBoundingClientRect().top + window.scrollY - topbarHeight;
      
          setTimeout(function(){
            window.scrollTo({
                top: parentPosition,
                behavior: 'smooth',
              });
          }, 0)
          
        }
    },

    pluralize: function(num: number | null | undefined, singular: string, plural: string): string {
        num = this.parseFloat(num);
        if(num == 1){
            return singular;
        }
        return plural;
    },
}

export default helpers
